// roomList.js - Updated structure for multilingual support
export const rooms = {
  hauntedhouse: {
    id: 'hauntedhouse',
    image: '/images/hauntedhouse.png',
    content: {
      de: {
        title: 'The Haunted House of Dark Data',
        description: `Ihr steht vor einem halb-verfallenen viktorianischen Anwesen. Motten flattern im fahlen Licht, das durch zerbrochene Fenster fällt. Hinter diesen Wänden lauern die Schrecken der Daten – gesammelt, aber nie genutzt, und vermutlich für immer vergessen. Die Eingangstür öffnet sich quietschend von selbst und gibt den Blick frei in einen dämmrig beleuchteten Raum.`,
        question: 'Was wollt ihr tun?'
      },
      en: {
        title: 'The Haunted House of Dark Data',
        description: `You stand before a half-decayed Victorian mansion. Moths flutter in the pale light falling through broken windows. Behind these walls lurk the horrors of data – collected but never used, and presumably forgotten forever. The entrance door creaks open by itself, revealing a dimly lit room.`,
        question: 'What do you want to do?'
      }
    },
    choices: [
      {
        text: {
          de: 'Warten',
          en: 'Wait'
        },
        response: {
          de: 'Während ihr wartet, beginnt eine Uhr zu ticken - erst leise, dann immer lauter. Ein kalter Schauer läuft euch den Rücken hinunter. Ihr wisst, dass ihr nicht mehr länger warten könnt und euch den Schrecken stellen müsst, die im Haus lauern.',
          en: 'While you wait, a clock begins to tick - first quietly, then louder and louder. A cold shiver runs down your spine. You know you can no longer wait and must face the horrors lurking in the house.'
        },
        nextRoom: 'hauntedhouse'
      },
      {
        text: {
          de: 'Eintreten',
          en: 'Enter'
        },
        response: {
          de: 'Jeder Schritt auf den alten Dielen knarrt unter eurem Gewicht. Die Porträts an den Wänden scheinen euch mit stummen Blicken vorwurfsvoll zu folgen, während ihr euch in die Dunkelheit vorwagt.',
          en: 'Every step on the old floorboards creaks under your weight. The portraits on the walls seem to follow you with silent, reproachful gazes as you venture into the darkness.'
        },
        nextRoom: 'eingang'
      }
    ]
  },

  eingang: {
    id: 'eingang',
    image: '/images/entrance.png',
    content: {
      de: {
        title: 'Das Foyer der fehlenden Use Cases',
        description: `Ihr betretet einen riesigen Raum. Es herrscht große Leere und Unordnung zugleich. Verlassene Artefakte zeugen von Ideen der Vergangenheit. Niemand weiß mehr, von wem sie stammen und für welchen Zweck sie ursprünglich gedacht waren. Manche hatten nie einen Zweck. In der Luft liegt der Geruch von Staub und vergessenen Versprechungen.

        An den Wänden hängen Poster, die „datengetriebene Entscheidungen" verheißen und das Zeitalter von „Big Data" ankündigen. Doch die Slogans verhallen ungehört, ungesehen und ungelesen hinter den Spinnweben. Big Data ist die Antwort auf die Fragen, die niemand gestellt hat. Du erkennst sofort: Es ist das Foyer der fehlenden Use Cases – ein Ort, an dem die Kluft zwischen Strategie und Umsetzung spürbar wird.

        Die Daten wären da. In Hülle und Fülle. Aber keiner fühlt sich zuständig. Sie werden nicht genutzt, nicht gepflegt, nicht verstanden. Nur etwa ein Drittel wird tatsächlich verwendet - der Rest wartet auf eine Zukunft, die vielleicht nie kommt.

        Und da ist es: Das eigentliche Gespenst in diesem Raum. Es ist die Diskrepanz zwischen dem Anspruch an datengetriebene Entscheidungen und der Realität im Alltag.`,
        question: 'Wie möchtet ihr weiter vorgehen?'
      },
      en: {
        title: 'The Foyer of Missing Use Cases',
        description: `You enter a huge room. There is both great emptiness and disorder. Abandoned artifacts testify to ideas from the past. No one knows anymore who they came from and for what purpose they were originally intended. Some never had a purpose. The air smells of dust and forgotten promises.

        Posters hang on the walls promising "data-driven decisions" and announcing the age of "Big Data." But the slogans echo unheard, unseen, and unread behind the cobwebs. Big Data is the answer to questions no one has asked. You immediately recognize: This is the foyer of missing use cases – a place where the gap between strategy and implementation becomes tangible.

        The data would be there. In abundance. But no one feels responsible. It's not used, not maintained, not understood. Only about a third is actually used - the rest waits for a future that may never come.

        And there it is: The real ghost in this room. It's the discrepancy between the aspiration for data-driven decisions and the reality of everyday life.`,
        question: 'How would you like to proceed?'
      }
    },
    choices: [
      {
        text: {
          de: 'Auf die Suche nach passenden Use Cases begeben',
          en: 'Go searching for suitable use cases'
        },
        response: {
          de: 'Ihr macht euch auf den Weg in die Zukunft - in der Hoffnung, dass die Daten irgendwann doch noch nützlich werden.',
          en: 'You set off into the future - hoping that the data will somehow become useful someday.'
        },
        nextRoom: 'zukunft'
      },
      {
        text: {
          de: 'Lieber nichts löschen - vielleicht eine Bestandsaufnahme machen?',
          en: 'Better not delete anything - maybe do an inventory?'
        },
        response: {
          de: 'Ihr entscheidet euch für eine Bestandsaufnahme und betretet einen dunklen Keller, in dem alles gelagert wird – zur Sicherheit.',
          en: 'You decide on an inventory and enter a dark basement where everything is stored – just to be safe.'
        },
        nextRoom: 'keller'
      }
    ]
  },

  keller: {
    id: 'keller',
    image: '/images/attic.png',
    content: {
      de: {
        title: 'Der Abstellkeller der Archivierung',
        description: 'Ihr steigt hinab in den düsteren Keller. Hier stapeln sich unbeschriftete Backup-Bänder, private USB-Sticks und alte Aktenordner wie Ruinen aus Papier. Die Luft riecht nach veralteten Systemen und ungenutzten Datenbeständen. Manche Schilder warnen vor „Legacy-Systemen", andere kann man nicht mehr entziffern. Euch wird schnell klar: Data Debt war vor euch hier. Genau wie bei technische Schulden, kam es hier in der Vergangenheit durch spontane und immer zeitkritische Entscheidungen, wechselnde Zuständigkeiten und schlechte Dokumentation zu einem undurchdringlichen Datenarchiv. Niemand weiß mehr, was sich auf den CDs, in den Laufwerken und den Aufzeichnungen auf Papier befindet. Das Röhren der Serverkühlungen erinnert euch aber daran, dass ihr auch nichts verrücken dürft. Die Systeme müssen weiterbetrieben werden, denn irgendwo könnten noch Daten schlummern, die ihr auf keinen Fall löschen solltet.',
        question: 'Wie möchtet ihr mit diesem Keller umgehen?'
      },
      en: {
        title: 'The Storage Basement of Archiving',
        description: 'You descend into the gloomy basement. Here, unlabeled backup tapes, private USB sticks, and old file folders stack up like paper ruins. The air smells of outdated systems and unused data stocks. Some signs warn of "legacy systems," others are no longer decipherable. You quickly realize: Data debt was here before you. Just like with technical debt, spontaneous and always time-critical decisions, changing responsibilities, and poor documentation led to an impenetrable data archive. No one knows anymore what\'s on the CDs, in the drives, and in the paper records. The humming of server cooling reminds you that you mustn\'t move anything either. The systems must continue running because somewhere there might still be data that you absolutely shouldn\'t delete.',
        question: 'How would you like to deal with this basement?'
      }
    },
    choices: [
      {
        text: {
          de: 'Lösch- und Aufbewahrungsrichtlinien endlich umsetzen',
          en: 'Finally implement deletion and retention policies'
        },
        response: {
          de: 'Beim Versuch, Ordnung zu schaffen, stellt ihr fest: Auf manche Daten könnt ihr gar nicht mehr zugreifen. Ihr müsst wohl tiefer – ins unzugängliche Datendachgeschoss.',
          en: 'In your attempt to create order, you discover: You can no longer access some data at all. You\'ll probably have to go deeper – into the inaccessible data attic.'
        },
        nextRoom: 'dachboden'
      },
      {
        text: {
          de: 'Datenspeicherungskonzept modernisieren',
          en: 'Modernize data storage concept'
        },
        response: {
          de: 'Speicher wird immer günstiger und du sparst Kosten ein. Du gelangst in den Speicher der Speicherplätze.',
          en: 'Storage is getting cheaper and you save costs. You reach the storage of storage spaces.'
        },
        nextRoom: 'speicher'
      }
    ]
  },

  speicher: {
    id: 'speicher',
    image: '/images/library.png',
    content: {
      de: {
        title: 'Der Speicher der Speicherplätze',
        description: `Ihr betretet einen übervollen Raum - Daten stapeln sich bis unter die Decke. Netzlaufwerke, USB-Sticks, SharePoints, E-Mail-Anhänge, lokale Ordner, Datenbanken, Cloud-Backups - selbst CDs und Bandlaufwerke sind noch da. Alles wurde irgendwo gespeichert. Meist mehrfach. 

        Jede Abteilung hat ihre eigene Version - aus Misstrauen, Kontrollbedürfnis oder reiner Gewohnheit. Datenhoarding ist hier keine Ausnahme, sondern Kultur. Backup der Backups, Redundanzen auf Redundanzen. ROT-Daten (Redundant, Obsolete, Trivial) machen den Großteil des Inhalts aus. 

        Keiner weiß, wo die aktuelle Version liegt. Die Suche nach der Wahrheit endet oft in einer Wand aus Datensilos.`,
        question: 'Wie wollt ihr mit diesem Datendschungel umgehen?'
      },
      en: {
        title: 'The Storage of Storage Spaces',
        description: `You enter an overcrowded room - data stacks up to the ceiling. Network drives, USB sticks, SharePoints, email attachments, local folders, databases, cloud backups - even CDs and tape drives are still there. Everything was stored somewhere. Usually multiple times.

        Each department has its own version - out of distrust, need for control, or pure habit. Data hoarding is not an exception here, but culture. Backups of backups, redundancies upon redundancies. ROT data (Redundant, Obsolete, Trivial) makes up most of the content.

        No one knows where the current version is. The search for truth often ends in a wall of data silos.`,
        question: 'How do you want to deal with this data jungle?'
      }
    },
    choices: [
      {
        text: {
          de: 'Teampräferenzen zulassen und dezentral speichern',
          en: 'Allow team preferences and store decentrally'
        },
        response: {
          de: 'Ihr entscheidet euch für maximale Flexibilität - auch wenn manche Daten nie wiedergefunden werden. Willkommen in der Nische der unzugänglichen Daten.',
          en: 'You decide on maximum flexibility - even if some data will never be found again. Welcome to the niche of inaccessible data.'
        },
        nextRoom: 'nische'
      },
      {
        text: {
          de: 'Nur relevante Speicherorte definieren und zentralisieren',
          en: 'Define only relevant storage locations and centralize'
        },
        response: {
          de: 'Ihr plant ein zentrales, sicheres System. Doch die Gefahr veralteter Daten bleibt. Ihr betretet den Raum der unbrauchbaren Daten.',
          en: 'You plan a central, secure system. But the danger of outdated data remains. You enter the room of unusable data.'
        },
        nextRoom: 'dachboden'
      }
    ]
  },

  zukunft: {
    id: 'zukunft',
    image: '/images/futureapplications.png',
    content: {
      de: {
        title: 'Das Zimmer der zukünftigen Anwendung',
        description: 'Ein Raum voller Hoffnung, Eventualität und Prokrastination. Hier stapeln sich Sensor-Daten, Logfiles und Tracking-Informationen mit dem Etikett "Für später!". Eine Glaskugel zeigt unklare Visionen von Machine-Learning-Anwendungen und KI-Projekten. Gigantische Data Lakes sind zu Data Swamps verkommen – an einer Ecke blubbert es. Ein Gespenst kommt aus der Wand, öffnet die eine Seite seines durchscheinenden Trench-Coats und murmelt: „Speicher ist billig, braucht ihr noch mehr?"',
        question: 'Die Zukunft bleibt nebulös. Doch wie sieht eure aus?'
      },
      en: {
        title: 'The Room of Future Applications',
        description: 'A room full of hope, eventuality, and procrastination. Here sensor data, log files, and tracking information pile up with the label "For later!". A crystal ball shows unclear visions of machine learning applications and AI projects. Gigantic data lakes have become data swamps – it\'s bubbling in one corner. A ghost emerges from the wall, opens one side of its translucent trench coat, and murmurs: "Storage is cheap, do you need more?"',
        question: 'The future remains nebulous. But what does yours look like?'
      }
    },
    choices: [
      {
        text: {
          de: 'KI ist der Use Case. Wir brauchen die Daten auf jeden Fall.',
          en: 'AI is the use case. We definitely need the data.'
        },
        response: {
          de: 'Ihr entscheidet euch für Quantität statt Qualität. Euer Data Swamp wächst – ihr werdet in den Raum der Speicherplätze geworfen.',
          en: 'You decide on quantity over quality. Your data swamp grows – you are thrown into the room of storage spaces.'
        },
        nextRoom: 'speicher'
      },
      {
        text: {
          de: 'Relevanz prüfen und Metadaten-Management einführen',
          en: 'Check relevance and introduce metadata management'
        },
        response: {
          de: 'Ihr wollt euch durch den Data Swamp kämpfen. Mit strukturierter Bewertung und dokumentierter Relevanz baut ihr ein robustes Datenmodell. Aber was ist das da hinten? Ihr stoßt auf unzugängliche Daten.',
          en: 'You want to fight your way through the data swamp. With structured evaluation and documented relevance, you build a robust data model. But what\'s that back there? You encounter inaccessible data.'
        },
        nextRoom: 'dachboden'
      },
      {
        text: {
          de: 'Warten auf neue Ressourcen oder den richtigen Use Case',
          en: 'Wait for new resources or the right use case'
        },
        response: {
          de: 'Je länger ihr wartet, desto nutzloser werden die Daten – Ab in die Nische der nutzlosen Daten!',
          en: 'The longer you wait, the more useless the data becomes – Off to the niche of useless data!'
        },
        nextRoom: 'nische'
      }
    ]
  },

  dachboden: {
    id: 'dachboden',
    image: '/images/inaccessibledata.png',
    content: {
      de: {
        title: 'Das unzugängliche Daten-Dachgeschoss',
        description: `Ein verstaubtes Dachgeschoss, zu dem es keinen Schlüssel mehr gibt. Die Tür ist verzogen, das Schloss rostig. Drinnen: Daten - vorhanden, aber nutzlos. Niemand weiß, wem sie gehören, wie man darauf zugreift oder ob sie überhaupt noch stimmen.

        Hier lagern verwaiste Altsysteme, Datensilos einzelner Abteilungen, verschlüsselte Archive ohne Zugang. Manche Daten liegen in exotischen Formaten vor, für die es längst keine kompatiblen Tools mehr gibt. Niemand fühlt sich verantwortlich - Ownership existiert hier nicht.

        Data Scientists verlieren hier oben täglich Stunden, auf der Suche nach dem vielleicht vorhandenen Datenzugang. Diese Ineffizienz kostet Zeit, Geld und Vertrauen - und sie blockiert jede datengetriebene Entscheidung. „Miete kostet dieser Raum aber sicher trotzdem," denkt ihr euch im Stillen, bevor ihr überlegt, wie ihr nun weitermachen wollt. Es muss doch einen Ausweg geben!`,
        question: 'Wie wollt ihr mit diesen vergessenen Daten umgehen?'
      },
      en: {
        title: 'The Inaccessible Data Attic',
        description: `A dusty attic for which there is no key anymore. The door is warped, the lock rusty. Inside: data - present but useless. No one knows who they belong to, how to access them, or whether they're even still correct.

        Here lie orphaned legacy systems, data silos of individual departments, encrypted archives without access. Some data exists in exotic formats for which there are no longer compatible tools. No one feels responsible - ownership doesn't exist here.

        Data scientists lose hours up here daily, searching for possibly existing data access. This inefficiency costs time, money, and trust - and it blocks every data-driven decision. "But this room surely still costs rent," you think silently before considering how to proceed. There must be a way out!`,
        question: 'How do you want to deal with this forgotten data?'
      }
    },
    choices: [
      {
        text: {
          de: 'Löschung anstoßen und Platz für Neues schaffen',
          en: 'Initiate deletion and create space for new things'
        },
        response: {
          de: 'Ihr trennt euch von der Altlast. Das schafft Klarheit, reduziert Kosten - und ebnet den Weg für eine aktive Datenstrategie.',
          en: 'You separate yourselves from the legacy burden. This creates clarity, reduces costs - and paves the way for an active data strategy.'
        },
        nextRoom: 'ausgang'
      },
      {
        text: {
          de: 'Verantwortlichkeiten und Regeln einführen',
          en: 'Introduce responsibilities and rules'
        },
        response: {
          de: 'Ihr startet ein Governance-Projekt - aufwendig, teuer, aber notwendig. Willkommen im Raum der hohen Aufwände.',
          en: 'You start a governance project - elaborate, expensive, but necessary. Welcome to the room of high expenses.'
        },
        nextRoom: 'kosten'
      }
    ]
  },

  nische: {
    id: 'nische',
    image: '/images/niche.png',
    content: {
      de: {
        title: 'Die Nische der Nicht-Brauchbarkeit',
        description: `Ihr könnt den Raum kaum betreten. Überall stapeln sich alte Speicherträger, verstaubte CDs, Excel-Tabellen ohne Struktur und JSON-Dateien ohne Kontext. Tippfehler, leere Felder, kryptische Variablen - niemand traut diesen Daten. 

        Es fühlt sich an wie Opas Schallplattensammlung: Sicher wertvoll, aber niemand in der Familie besitzt noch einen Plattenspieler. Hier lagern die Datensätze, die zwar physisch existieren, aber für niemanden mehr Sinn ergeben.

        Die Daten sind entweder zu alt, zu unvollständig, zu fehlerhaft. Ohne Kontext und Metadaten verlieren sie ihren Wert. Wer sie dennoch nutzt, riskiert Fehlinterpretationen und kostspielige Irrtümer. Wer sie ignoriert, zahlt trotzdem - mit Speicherplatz und Zeit.

        Willkommen im Niemandsland der Datenqualität.`,
        question: 'Was wollt ihr mit diesen Daten tun?'
      },
      en: {
        title: 'The Niche of Non-Usability',
        description: `You can barely enter the room. Everywhere old storage media pile up, dusty CDs, Excel tables without structure, and JSON files without context. Typos, empty fields, cryptic variables - no one trusts this data.

        It feels like grandpa's record collection: Surely valuable, but no one in the family owns a record player anymore. Here lie the datasets that physically exist but no longer make sense to anyone.

        The data is either too old, too incomplete, too flawed. Without context and metadata, they lose their value. Those who still use them risk misinterpretations and costly errors. Those who ignore them still pay - with storage space and time.

        Welcome to the no-man's land of data quality.`,
        question: 'What do you want to do with this data?'
      }
    },
    choices: [
      {
        text: {
          de: 'Recherchieren, bereinigen und dokumentieren',
          en: 'Research, clean, and document'
        },
        response: {
          de: 'Ihr startet ein aufwändiges Programm zur Qualitätssicherung. Ein langer Weg, aber mit nachhaltigem Effekt - willkommen im Raum der hohen Kosten und Aufwände.',
          en: 'You start an elaborate quality assurance program. A long road, but with sustainable effect - welcome to the room of high costs and expenses.'
        },
        nextRoom: 'kosten'
      },
      {
        text: {
          de: 'Einfach löschen - radikaler Neuanfang',
          en: 'Simply delete - radical fresh start'
        },
        response: {
          de: 'Ihr löscht alte CRM-Daten und führt wochenlange Debatten. Doch am Ende entsteht Raum für eine echte Datenstrategie und neue Use Cases.',
          en: 'You delete old CRM data and lead week-long debates. But in the end, space is created for a real data strategy and new use cases.'
        },
        nextRoom: 'ausgang'
      },
      {
        text: {
          de: 'Ignorieren - man weiß ja nie...',
          en: 'Ignore - you never know...'
        },
        response: {
          de: 'Ihr entscheidet euch, die Daten zu behalten - aber ohne sie zu verstehen oder zu nutzen. Ihr kehrt zurück in den Abstellkeller der Archivierung.',
          en: 'You decide to keep the data - but without understanding or using it. You return to the storage basement of archiving.'
        },
        nextRoom: 'keller'
      }
    ]
  },

  kosten: {
    id: 'kosten',
    image: '/images/chamberofcosts.png',
    content: {
      de: {
        title: 'Die Kammer der Kosten',
        description: `Ein unheilvoller Raum, in dem sich die wahren Auswirkungen ungenutzter Daten materialisieren. Zwischen flackernden Monitoren und überladenen Serverracks stapeln sich Berichte über mühsame Datenaufbereitungen, Kostenbelege und Cloud-Abrechnungen.

        Tinkturen und Reagenzien blubbern in Glasgefäßen - Symbol für Prozesse, deren Ausgang niemand mehr kontrolliert. Alte Daten verlangsamen Systeme, verhindern Automatisierung, blockieren Projekte. Und der CO₂-Zähler an der Wand läuft unaufhörlich: 6,5 Millionen Tonnen entstehen allein durch deutsche Rechenzentren.

        Eure Cloud-Kosten explodieren, Migrationen scheitern an Altlasten. Aus dem Nebenzimmer ruft der CTO und fragt: „Was bringt uns das eigentlich?" Ihr seht euch um: Jeder gespeicherte Datensatz - sei er noch so obskur - erzeugt Stromkosten, Kühlaufwand, Backup-Komplexität und Wartungspflicht. Ihr könnt das dem CTO nicht erklären. Das Innovationsbudget schwindet – der Datenberg wächst.`,
        question: 'Wie wollt ihr mit diesem Aufwand umgehen?'
      },
      en: {
        title: 'The Chamber of Costs',
        description: `An ominous room where the true impacts of unused data materialize. Between flickering monitors and overloaded server racks, reports about laborious data preparation, cost receipts, and cloud bills pile up.

        Tinctures and reagents bubble in glass vessels - symbols of processes whose outcome no one controls anymore. Old data slows down systems, prevents automation, blocks projects. And the CO₂ counter on the wall runs incessantly: 6.5 million tons are generated by German data centers alone.

        Your cloud costs explode, migrations fail due to legacy burdens. From the next room, the CTO calls and asks: "What does this actually bring us?" You look around: Every stored dataset - no matter how obscure - generates electricity costs, cooling effort, backup complexity, and maintenance obligations. You can't explain this to the CTO. The innovation budget dwindles – the data mountain grows.`,
        question: 'How do you want to deal with this expense?'
      }
    },
    choices: [
      {
        text: {
          de: 'Bluffen: „Wir brauchen das alles für zukünftige KI-Projekte!"',
          en: 'Bluff: "We need all this for future AI projects!"'
        },
        response: {
          de: 'Ihr gebt euch optimistisch - und lagert weiter ein, in der Hoffnung auf künftige Erkenntnisse. Willkommen im Zimmer der zukünftigen Anwendung.',
          en: 'You remain optimistic - and continue storing, hoping for future insights. Welcome to the room of future applications.'
        },
        nextRoom: 'zukunft'
      },
      {
        text: {
          de: 'Mit einem Report den echten Mehrwert aufzeigen',
          en: 'Show real added value with a report'
        },
        response: {
          de: 'Ihr bündelt die relevanten Informationen, zeigt echten Nutzen auf und überzeugt das Management. Ihr kehrt zurück ins Foyer der Use Cases - bereit für echte Entscheidungen.',
          en: 'You bundle the relevant information, demonstrate real value, and convince management. You return to the foyer of use cases - ready for real decisions.'
        },
        nextRoom: 'ausgang'
      },
      {
        text: {
          de: 'Alles löschen - radikale Massendatenlöschung',
          en: 'Delete everything - radical mass data deletion'
        },
        response: {
          de: 'Ihr löscht mit Nachdruck - auch wenn nicht alles vorher geprüft wurde. Vielleicht war es mutig. Vielleicht war es zu viel.',
          en: 'You delete with emphasis - even though not everything was checked beforehand. Maybe it was brave. Maybe it was too much.'
        },
        nextRoom: null
      }
    ]
  },

    ausgang: {
    id: 'ausgang',
    image: '/images/entrance.png',
    content: {
      de: {
        title: 'Der Ausgang - Lessons Learned',
        description: `Ihr steht wieder im Foyer. Doch jetzt seht ihr es mit anderen Augen. Die Erfahrungen haben euch gelehrt, dass Dark Data kein unabwendbares Schicksal sind. Ihr habt Ideen entwickelt, wie ihr damit umgehen könnt.

**Eure Erkenntnisse**:
- Rund 80% der Daten bleiben ungenutzt - das kostet unnötige Ressourcen 
- Klare Use Cases sind der Schlüssel zum Erfolg und der notwendige erste Schritt
- Governance ist Investment und Hygiene-Faktor, nicht Kostentreiber
- Qualität schlägt Quantität, Dokumentation schlägt Exploration
- Compliance ist Kompass, nicht Hindernis

Das Datenhaus kann ein Ort der Wertschöpfung werden – mit der richtigen Strategie.`,
        question: 'Wie möchtet ihr weitermachen?'
      },
      en: {
        title: 'The Exit - Lessons Learned',
        description: `You’re back in the foyer. But now you see it with new eyes. Your journey has taught you that dark data is not inevitable. You’ve developed ideas for how to handle it.

**Your insights**:
- Around 80% of data remains unused – wasting valuable resources
- Clear use cases are the key to success and the necessary first step
- Governance is an investment and hygiene factor, not a cost driver
- Quality beats quantity, documentation beats exploration
- Compliance is a compass, not a roadblock

The data house can become a place of value creation – with the right strategy.`,
        question: 'How would you like to proceed?'
      }
    },
    choices: [
      {
        text: {
          de: 'Datenhaus in Ordnung bringen',
          en: 'Put the data house in order'
        },
        response: {
          de: 'Ihr geht zurück mit einem Plan: Use Cases definieren, Governance etablieren, Qualität sichern.',
          en: 'You return with a plan: define use cases, establish governance, ensure quality.'
        },
        nextRoom: 'governance',
        goodDecision: true
      },
      {
        text: {
          de: 'Neue Runde - andere Entscheidungen treffen',
          en: 'New round - make different decisions'
        },
        response: {
          de: 'Ihr wollt sehen, was passiert, wenn ihr andere Wege geht. Learning by doing.',
          en: 'You want to see what happens when you take a different path. Learning by doing.'
        },
        nextRoom: 'hauntedhouse'
      },
      {
        text: {
          de: 'Haus verlassen - externe Hilfe holen',
          en: 'Leave the house - get external help'
        },
        response: {
          de: 'Ihr erkennt: Das ist ein Job für Experten. Professionelle Hilfe ist die beste Investition.',
          en: 'You realize: This is a job for experts. Professional help is the best investment.'
        },
        nextRoom: null,
        ending: 'professional_help'
      }
    ]
  },

  governance: {
    id: 'governance',
    image: '/images/happygovernance.png',
    content: {
      de: {
        title: 'Der Salon der Data Governance',
        description: `Ihr öffnet die letzte Tür – und steht in einem hellen Salon, in dem aus dem einstigen Spukhaus ein heimeliges Daten-Zuhause geworden ist. An den Wänden hängt ein **Governance-Kanban-Board**: Von „Use-Case-Idee“ über „Data Contract signiert“ bis „Datensatz gelöscht“. Daneben leuchtet ein **Löschfristen-Dashboard** rot, gelb und grün und erinnert Data Owner und -Stewards an ihre Pflichten.  

Statt staubiger Kisten seht ihr **gläserne Vitrinen** – jeder Datensatz ist im Catalog etikettiert, Version, Qualitätsscore und Verantwortliche sind mit einem Blick erkennbar. Ein KI-Butler patrouilliert durch die Infrastruktur, identifiziert Dubletten, schlägt Archivierung oder Löschung vor und wirft Fehlermeldungen automatisiert in den Slack-Channel eures Teams.  

Hier beginnt jedes Vorhaben **mit dem Use Case**: Ohne definierten Nutzen, Metriken und ein klares Data Contract wandert nichts ins Warehouse. Speicherstrategien verhindern dreifache Ablagen, Data-Quality-Gates blocken fehlerhafte Uploads, und ein monatlicher „Data Health Check“ prüft, ob Governance-Regeln wirklich gelebt werden.  

Dank **Data-Mesh-Prinzipien** verschmelzen zentrale Standards mit dezentraler Verantwortung: Domänenteams modellieren ihre Datenprodukte in dbt, Observability-Monitore glimmen beruhigend grün, und die CO₂-Uhr steht fast still. In dieser Atmosphäre entstehen Entscheidungen – kein Datenstaub mehr. Das Haus ist endlich ein Zuhause.`,
        question: 'Und nun?'
      },
      en: {
        title: 'The Data Governance Parlor',
        description: `You open the final door – and step into a bright parlor where the haunted house has become a cozy data home. On the walls hangs a **governance Kanban board**: from “Use case idea” to “Data contract signed” to “Dataset deleted.” Next to it glows a **deletion-deadline dashboard** in red, yellow, and green, reminding data owners and stewards of their duties.

Instead of dusty boxes, you see **glass display cases** – each dataset is labeled in the catalog, with version, quality score, and responsible persons clearly visible. An AI butler patrols the infrastructure, identifies duplicates, suggests archiving or deletion, and automatically reports errors in your team’s Slack channel.

Here, every project starts **with a use case**: nothing enters the warehouse without defined value, metrics, and a clear data contract. Storage strategies avoid duplication, data-quality gates block faulty uploads, and a monthly “data health check” ensures that governance rules are followed.

Thanks to **data mesh principles**, central standards blend with decentralized responsibility: domain teams model their data products in dbt, observability monitors glow green with calm, and the CO₂ clock almost stands still. In this atmosphere, decisions flourish – no more data dust. The house is finally a home.`,
        question: 'And now?'
      }
    },
    choices: [
      {
        text: {
          de: 'Regelmäßige Data-Health-Checks und kontinuierliche Optimierung',
          en: 'Regular data health checks and continuous improvement'
        },
        response: {
          de: 'Ihr verankert einen zyklischen Audit-Prozess, schärft Löschfristen und haltet Data Contracts aktuell – das Datenhaus bleibt dauerhaft in Bestform.',
          en: 'You implement a recurring audit process, refine deletion deadlines, and keep data contracts up to date – the data house remains in top shape.'
        },
        nextRoom: null,
        goodDecision: true,
        ending: 'home_sweet_home'
      },
      {
        text: {
          de: 'Wir sind fertig – Füße hochlegen',
          en: 'We’re done – time to relax'
        },
        response: {
          de: 'Bequemlichkeit siegt – doch erste Daten schleichen sich wieder ungeprüft ein. Langsam zieht Nebel auf … Willkommen zurück im Haunted House.',
          en: 'Complacency wins – but data starts creeping in again unchecked. The fog begins to rise... Welcome back to the Haunted House.'
        },
        nextRoom: 'hauntedhouse'
      },
      {
        text: {
          de: 'Neue Daten sammeln und die freien Speicherkapazitäten nutzen',
          en: 'Collect new data and use the available storage capacity'
        },
        response: {
          de: 'Ohne Use Case und Contract wächst der Datenberg erneut – und die Kostenkammer öffnet rasch ihre Pforten.',
          en: 'Without a use case and contract, the data pile grows again – and the cost chamber opens its doors quickly.'
        },
        nextRoom: 'kosten'
      }
    ]
  }
};



// Helper function to get room content in specific language
export const getRoomContent = (roomId, language = 'de') => {
  const room = rooms[roomId];
  if (!room) return null;
  
  return {
    id: room.id,
    image: room.image,
    title: room.content[language]?.title || room.content.de.title,
    description: room.content[language]?.description || room.content.de.description,
    question: room.content[language]?.question || room.content.de.question,
    choices: room.choices.map(choice => ({
      text: choice.text[language] || choice.text.de,
      response: choice.response[language] || choice.response.de,
      nextRoom: choice.nextRoom
    }))
  };
};
